import React from 'react'
import IconDownload from 'assets/icons/group/IconDownloadWhite.svg'

export default () => <img alt='download-icon' src={IconDownload} />